module.exports = {
  chirpstackToken: process.env.CHIRP_AUTH_TOKEN,
  pageLimit: process.env.PAGE_LIMIT || 10,
  socketURL: process.env.SOCKET_URL,
};
